import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme();

const CustomTheme = props => {
  return <MuiThemeProvider theme={theme}>{props.children}</MuiThemeProvider>;
};

export default CustomTheme;



// WEBPACK FOOTER //
// ./src/CustomTheme.js